import Swiper from "swiper";
import {Controller, Navigation, Autoplay, Pagination, EffectFade} from 'swiper/modules';

export default class Home {
    constructor() {
        if (document.getElementById('home') !== null) {
            this.initSocial();
            this.sideSlider();
            this.helpSlider();
            this.partners();
        }
    }

    partners() {
        if (document.querySelector('#home #partners')) {
            const firstImages = document.querySelectorAll('.first img');
            const secondImages = document.querySelectorAll('.second img');
            const thirdImages = document.querySelectorAll('.third img');

            firstImages.forEach((img, key) => {
                if (key > 3) {
                    img.classList.add('d-none')
                }
            })

            secondImages.forEach((img, key) => {
                if (key > 3) {
                    img.classList.add('d-none')
                }
            })

            thirdImages.forEach((img, key) => {
                if (key > 3) {
                    img.classList.add('d-none')
                }
            })

            setInterval(() => {
                initLogosAnimation();
            }, 3000)

            function initLogosAnimation() {
                const items = document.querySelectorAll('#partners .item');

                const randomItem = Math.floor(Math.random() * items.length);
                const item = items[randomItem];

                const allImages = item.querySelectorAll('img.d-none');

                if (allImages.length) {
                    const randomImage = Math.floor(Math.random() * allImages.length);
                    const selectedImage = allImages[randomImage];
                    const image = selectedImage.cloneNode();
                    selectedImage.remove();

                    image.style.opacity = 0;

                    const visibleImages = item.querySelectorAll('img:not(.d-none)');
                    const randomVisibleImage = visibleImages[Math.floor(Math.random() * visibleImages.length)];

                    randomVisibleImage.parentNode.insertBefore(image, randomVisibleImage.nextSibling);

                    randomVisibleImage.style.opacity = 0;

                    window.setTimeout(() => {
                        randomVisibleImage.classList.add('d-none');
                        image.classList.remove('d-none');

                        window.setTimeout(() => {
                            image.style.opacity = 1;
                        }, 800)
                    }, 800)
                }
            }
        }
    }

    sideSlider() {
        new Swiper('#sideSlider .swiper-container', {
            slidesPerView: 1,
            loop: true,
            modules: [Autoplay, EffectFade],
            autoplay: {
                delay: 3000,
            },
            effect: 'fade'
        });
    }

    helpSlider() {
        new Swiper('#helpSlider .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: true,
            modules: [Autoplay],
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                }
            }
        });
    }

    initSocial() {
        new Swiper('#social .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 30,
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                },
                1200: {
                    slidesPerView: 4,
                }
            }
        });
    }
}
